/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-third-party-locked',
  templateUrl: './dialog-third-party-locked.component.html',
  styleUrls: ['./dialog-third-party-locked.component.scss']
})
export class DialogThirdPartyLockedComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public dialogRef: MatDialogRef<DialogThirdPartyLockedComponent>) {
  }

  ngOnInit(): void {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                    LISTENERS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(): void {
    this.dialogRef.close();
  }

}
